import { InputSize } from './types';

const sizeClasses = {
  'size.md': 'input-field-md',
  'size.lg': 'input-field-lg'
} satisfies Record<InputSize, string>;

export { sizeClasses };
